import {Component} from '@angular/core';
import {GnSiteInfo} from '../app-config/SiteInfo';

@Component({
  selector: 'gn-layout-center',
  templateUrl: './center.component.html',
  styleUrls: ['./center.component.less']
})
export class GnLayoutCenterComponent {

  constructor(public siteInfo: GnSiteInfo) {
  }

}
